import axios from "axios";

export default class DragHandler {
  constructor(element) {
    this.element = element;
    this.dragOverCounter = 0;
  }

  determineDragAndDropCapable() {
    var div = document.createElement("div");
    return (
      ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
      "FormData" in window &&
      "FileReader" in window
    );
  }

  _increment() {
    const prev = this.dragOverCounter;
    this.dragOverCounter++;
    this._notify(prev);
  }

  _decrement() {
    const prev = this.dragOverCounter;
    this.dragOverCounter--;
    this._notify(prev);
  }

  _reset() {
    const prev = this.dragOverCounter;
    this.dragOverCounter = 0;
    this._notify(prev);
  }

  _notify(prev) {
    if (prev < 1 && this.dragOverCounter > 0) {
      if (this.startCallback) {
        this.startCallback();
      }
      return;
    }

    if (prev > 0 && this.dragOverCounter < 1) {
      if (this.stopCallback) {
        this.stopCallback();
      }
    }
  }

  subscribe() {
    ["drag", "dragstart", "dragend", "drop", "dragover"].forEach(
      function(evt) {
        this.element.addEventListener(
          evt,
          function(e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    ["dragenter"].forEach(
      function(evt) {
        this.element.addEventListener(
          evt,
          function(e) {
            this._increment();
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    ["dragleave"].forEach(
      function(evt) {
        this.element.addEventListener(
          evt,
          function(e) {
            this._decrement();
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    this.element.addEventListener(
      "drop",
      function(e) {
        this._reset();
        if (this.dropCallback) {
          const uri = e.dataTransfer.getData("text/uri-list");
          if (uri) {
            axios({
              url: uri,
              method: "GET",
              responseType: "blob" // important
            }).then(response => {
              if (!response) {
                return;
              }
              if (response.data && response.data.type && response.data.size) {
                this.dropCallback([response.data]);
              }
            });
          }

          if (e.dataTransfer.files && e.dataTransfer.files.length) {
            this.dropCallback(e.dataTransfer.files);
          }
        }
      }.bind(this)
    );
  }
}
